import { createRequest, getProxyHeadersPlugin } from '@direct-frontend/modules-request';
import { authorizePlugin } from './plugins/authorizePlugin';
import { MIME_TYPE_XLSX } from '../../lib/constants';
import { apiRequestCommon } from './apiRequestCommon';
import { getCSRFPlugin } from './plugins';

export const apiBlobRequest = createRequest({
    ...apiRequestCommon,
    timeout: 600_000,

    headers: {
        accept: MIME_TYPE_XLSX,
    },

    responseType: 'blob',

    jsonContentTypeHeaders: [MIME_TYPE_XLSX],
    plugins: [getProxyHeadersPlugin(['cookie', 'user-agent', 'accept-language']), getCSRFPlugin(), authorizePlugin()],
});
